import React from 'react';
import { DrinkGrid, Footer, Navbar } from '../../components';

export default function Drinks(){
    return(
        <div>
            <Navbar/>
            <DrinkGrid/>
            <Footer/>
        </div>
    )
}